
/**
 * Custom component for Romanza Wines by the Glass section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.5.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-10-07 (1.0.0) (jhoward)
 *      - Copy from Romanza_wineList.vue component to Bimini_wineList.vue component.
 *
 *    2023-04-17 (1.1.0) (jhoward)
 *      - <Bimini_wineList> component uses TypeScript.
 *      - <Bimini_wineList> section prop is required.
 *      - <Bimini_wineList> component sets a blank array for pricing types when displaying items grouped by price.
 *      - Remove unused methods from <Bimini_wineList>.
 *
 *    2023-06-19 (1.2.0) (jhoward)
 *      - <Bimini_wineList> supports section.ms_show_pricing_header.
 *
 *    2023-06-21 (1.2.1) (jhoward)
 *      - Default to 1 pricing type rather than 0 in <Bimini_wineList>.
 *
 *  2023-08-23 (1.3.0) (jhoward)
 *    - Use <menu-version> in <Bimini_wineList>.
 *
 *  2025-02-11 (1.4.0) (jhoward)
 *    - Add <menu-schedules> to the <Bimini_wineList> component if in admin view.
 *
 *  2025-04-08 (1.5.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <Bimini_wineList>.
 *    - Add textual and visual menu CSS tweaks to <Bimini_wineList>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";

export default defineComponent({
  components: {
    BiminiDefaultSection,
  },
  name: "Bimini_wineList",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
